import React, { useEffect, useState } from 'react';

import { SimpleView, CompositeView, GridView } from '@digital/ui';

import DemandasAndamento from './DemandasAndamento';
import DemandasConcluido from './DemandasConcluido';
import { verificarSeUsuarioAdministradorContrato, verificarSeUsuarioEPreSuprimento } from '@app/api/usuario';

const AcervoDemandante = () => {
  const [usuarioPreSuprimentos, setUsuarioPreSuprimentos] = useState<boolean>(false);
  const [usuarioAdmContratos, setUsuarioAdmContratos] = useState<boolean>(false);
  const [isLoad, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
  Promise.all([
    verificarSeUsuarioEPreSuprimento(),
    verificarSeUsuarioAdministradorContrato()
  ]).then(([preSup, admContrato]) => {
    setUsuarioPreSuprimentos(!!preSup); 
    setUsuarioAdmContratos(!!admContrato);
    setIsLoading(false);
  });
}, []);

  return (
    <SimpleView>
      <CompositeView>
        <GridView icon="ui-in_progress" title="Em Andamento" id="andamento">
          {!isLoad && <DemandasAndamento usuarioPreSuprimentosOuAdmContratos={usuarioPreSuprimentos || usuarioAdmContratos} />}
        </GridView>
        <GridView icon="ui-offline_pin" title="Concluídos / Cancelados" id="concluido">
           {!isLoad && <DemandasConcluido usuarioPreSuprimentosOuAdmContratos={usuarioPreSuprimentos || usuarioAdmContratos} />}
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};
export default AcervoDemandante;
